import { ImportProfessionalsPage } from "./ImportProfessionalsPage";
export default ImportProfessionalsPage;
